import { ROLE_TO_ASSIGNABLE_USER_ROLES } from '@/client/services/userRole/constants'
import type { UserAuthRole } from '@/client/services/userRole/types'

import hasUserRole from './hasUserRole'
import type { UserLike } from './types'

export default function getRolesUserCanAssign(user: UserLike): UserAuthRole[] {
  const assignableRolesSet = new Set<UserAuthRole>()
  Object.entries(ROLE_TO_ASSIGNABLE_USER_ROLES).forEach(([role, assignableRoles]) => {
    if (assignableRoles != null && hasUserRole(user, role as UserAuthRole)) {
      assignableRoles.forEach(aRole => {
        assignableRolesSet.add(aRole)
      })
    }
  })
  return Array.from(assignableRolesSet.values())
}
